import { css } from 'styled-components'
const sizes = {
  desktopXl: 2560,
  desktopL: 1440,
  desktop: 1024,
  tablet: 768,
  medium: 375,
  large: 425,
  // small: 320,
}

// Iterate through the sizes and create a media template
export const media = Object.keys(sizes).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media only screen and (min-width: ${sizes[label] / 16}rem) {
      ${css(...args)};
    }
  `

  return acc
}, {})
// ${ media.tablet`background: dodgerblue;` }

export const retina = (...args) => css`
  @media only screen and (min-device-pixel-ratio: 2),
    only screen and (min-resolution: 192dpi) {
    ${css(...args)};
  }
`

export const rem = px => `${px / 16}rem`

export const theme = {
  color: {
    font: '#344e63',
    grey: '#E5E5E5',
    red: '#FF4856',
    white: '#FFFFFF',
    navy: '#344E63',
    lightBlue: '#D2E1E5',
  },
}
